export enum RoleTypeEnum {
    Admin = 'Admin',
    FleetPerformanceAnalyst = 'FleetPerformanceAnalyst',
    OtherOdfjellUser = 'OtherOdfjellUser',
    PortOperator = 'PortOperator',
    ShipOperator = 'ShipOperator',
    ShipUser = 'ShipUser',
    Unknown = 'Unknown',
}
